// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@-webkit-keyframes _2V78Y{5%{opacity:1}50%{opacity:.35}95%{opacity:1}}@keyframes _2V78Y{5%{opacity:1}50%{opacity:.35}95%{opacity:1}}._2geox{padding:1.6rem 2.4rem 0;position:relative;width:calc(100% - 33.8rem);z-index:1031}", ""]);
// Exports
exports.locals = {
	"root": "_2geox",
	"fading": "_2V78Y"
};
module.exports = exports;
